import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndpoint';


@Injectable({
  providedIn: 'root'
})
export class CtvetstudentService {

  
  constructor(private http: HttpClient, private urlSignature: UrlSignature) { }

  saveStudentInfo(studentInfo: any): Observable<any> {
    return this.http.post(this.urlSignature.ctvetStudentRegister, studentInfo);
  }

  viewAllStudents(studentInfo: any): Observable<any> {
    return this.http.post(this.urlSignature.ctvetAllStudents, studentInfo);
  }
}
